module.exports = __webpack_public_path__ + "static/media/heroImage.6b176bfb.jpg";